import { render, staticRenderFns } from "./CustomFontsOption.vue?vue&type=template&id=dbc86a74"
import script from "./CustomFontsOption.vue?vue&type=script&lang=js"
export * from "./CustomFontsOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports